var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.938 18.53c-2.33-.006-4.65.036-7 .157v-.03c-18.72.97-37.354 4.835-53.782 11.5-5.895 9.737-7.003 18.63-3.22 31.655 2.543 8.748 7.697 19.177 15.69 31.594 9.697-6.747 25.94-10.26 42.468-10.5 17.92-.258 36.14 3.24 46.53 10.594 7.038-11.94 11.675-22.136 14.063-30.844C308.813 47.62 307.18 37.386 300 26l.47-.28c-13.496-4.296-28.377-6.64-43.533-7.032a188.48 188.48 0 0 0-7-.157zM324 36.157c2.096 9.886 1.745 20.437-1.28 31.47-4.985 18.167-16.32 38.006-34 62.655l-32.283 47.564-76.843 114.187-.313-.217-67.155 98.875 24.53-1.157-16.936 47.876 45.53-26.28-29.78 65.437 36.218-22.782 7 37.376 52.28-110.094-.405-.187L295.5 244.687l4.313-9 47.062-98.437C370.188 88.162 354.93 54.713 324 36.156zM165.72 42.78c-30.64 21.468-44.758 56.84-18.564 104.97L195 235.688l42.72-63.47-38-47.25c-2.668-3.34-4.54-6.492-5.69-9.437C180.9 97.14 172.23 81.58 168 67.03c-2.433-8.37-3.142-16.496-2.28-24.25zm142.75 218.126-46.595 97.72 71.594 131.937 4.842-36.157 37.907 7.406-25.47-47.375 58.875 24.782-32.656-57.408 23.655-5.718-92.156-115.188z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.4f7c62822b79c75a39f39c38bb6bbdcf.svg";
export { ForwardRef as ReactComponent };